import { createFeatureSelector, createSelector } from "@ngrx/store";
import { PaymentsState, paymentFeatureKey } from "./payments.reducers";

const selectFeature = createFeatureSelector<PaymentsState>(
  paymentFeatureKey
);
export const selectAllPayments = createSelector(
  selectFeature,
  (state) => Object.values(state.entities)
)

export const selectPaymentById = (id: string) =>
  createSelector(
    selectFeature,
    (state) => state.entities[id]
  );

export const selectPaymentsByStudentId = (studentId: number) => (state: any) => {
    return selectAllPayments(state).filter(payment => payment.student_id === studentId);
}


export const selectIsLoaded = createSelector(
    selectFeature,
    (state) => state.arePaymentsLoaded
  );

export const selectSelectedPayment = createSelector(
    selectFeature,
    (state) => {
      const selectedPaymentId = state.selectedPayment;
      return selectedPaymentId ? state.entities[selectedPaymentId] : null;
    }
);

export const selectPaymentFilter = createSelector(
    selectFeature,
    (state) => state.paymentFilter || "Alle"
);
  
export const selectOpenPayments = createSelector(
    selectFeature,
    (state) => state.openPayments
);

export const selectIsLoading = createSelector(
    selectFeature,
    (state) => state.isLoading
)
